/**
 * Production auth service entry. Used only for production builds so that
 * AuthService.dev is never in the dependency graph and cannot be bundled.
 */
import AuthServiceBase from './AuthService.base';
export default new AuthServiceBase();
